import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Autocomplete, { createFilterOptions }  from '@material-ui/lab/Autocomplete';
import {isEmpty,isUndefined, isNull,isObject} from 'lodash'
import { getnewKundByOrgnr,searchKundBasic,setThisserchedKund,getResetNullKontakterList,
    onSetZeroKundSearch
    //,getnewTooltipDetailsByOrgnr 
} from 'actions'
import { Grid } from '@material-ui/core';
import {Dialog,List,DialogContent ,ListItem ,ListItemText, InputAdornment } from '@material-ui/core/';
import CircularProgress from '@material-ui/core/CircularProgress';
import SearchIcon from '@material-ui/icons/Search';
import Tooltip from '@material-ui/core/Tooltip';
import IntlMessages from '../../../util/IntlMessages';

function mapStateToProps({auth,accountsData}) {
    const {AktivaKunder,KundSearch,searchedKundBasic,IsloadingSearch,KundSearchLoading,
        isPersonlig
        //,KundTooltipDetails
    } =accountsData
    const { authUser} = auth;
    return {
        authUser,AktivaKunder,KundSearch,searchedKundBasic,IsloadingSearch, KundSearchLoading,
        isPersonlig
        //,KundTooltipDetails
    };
}
function mapDispatchToProps(dispatch) {
    return {
        getnewKundByOrgnr: (userid,AFid,Orgnr) => dispatch(getnewKundByOrgnr(userid,AFid,Orgnr)),
       // getnewTooltipDetailsByOrgnr: (userid,AFid,Orgnr) => dispatch(getnewTooltipDetailsByOrgnr(userid,AFid,Orgnr)),
        searchKundBasic: (searchText, Afid, userid) => dispatch(searchKundBasic(searchText, Afid, userid)),
        setThisserchedKund: (Kund) => dispatch(setThisserchedKund(Kund)),
        getResetNullKontakterList: () => dispatch(getResetNullKontakterList()),
        onSetZeroKundSearch: () => dispatch(onSetZeroKundSearch()),
    };
}
const filter = createFilterOptions();

class KundAutoComplete extends Component {
    state={
        AktivaKunder:[] ,
        newKunder:[],
        searchedKund:[],
        KundSearch:{},
        Value:this.props.Value,
        isLoading:false,
        searchInAllData:false,
        newKund:{
            Orgnr:"",
            AF_kundnamn:"",
            MainAdress2:"",
            MainPost2:"",
            MainOrt2:"", 
            Source:"", 
            TokenA:"", 
        }
    }
    componentDidMount=()=>{
        this.props.getResetNullKontakterList()
        this.props.onSetZeroKundSearch()
        this.createData()
    }
    createData=()=>{
        
        let Data =[]
        Data = isEmpty(this.props.AktivaKunder)?[]:
        this.props.AktivaKunder.map(sdata =>{
            return {
                value:sdata.Orgnr,
                label:sdata.AF_kundnamn,
                Tele: sdata.main_tele,
                Email: sdata.main_email,
            }
        })
       
        this.setState({
            AktivaKunder:Data,
            FilterKund:Data
        })
    }
    componentDidUpdate=()=>{
        if(this.state.Value !== this.props.Value){
            this.setState({Value:this.props.Value})
        }
        if(this.state.KundSearch !== this.props.KundSearch){
            if(!isEmpty(this.props.KundSearch)){
                this.setState({
                    isLoading:false,
                })
            }
            this.setState({
                KundSearch:this.props.KundSearch,                
                newKund:{
                    Orgnr:this.props.KundSearch.Orgnr,
                    Orgnr_Af:this.props.KundSearch.Orgnr_Af,
                    AF_kundnamn:this.props.KundSearch.KundNamn,
                    MainAdress2:this.props.KundSearch.adress,
                    MainPost2:this.props.KundSearch.postnr,
                    MainOrt2:this.props.KundSearch.ort,
                    Source:this.props.KundSearch.Source,
                    TokenA:this.props.KundSearch.Active,
                }
            })
        }
        
    }
    selectthisKund=async (newValue)=>{
        if(!isEmpty(newValue)){
        this.setState({isLoading:true})
        const Orgnr = newValue.value;
        const userid = this.props.authUser.user_id;
        const AFid = this.props.authUser.user_Afid;
        await this.props.getnewKundByOrgnr(userid,AFid,Orgnr)
        setTimeout(async ()=>{await this.props.selectthisKund(newValue)},500)
        }
    }
    GetThisEjAktiveKunder=async(newValue)=>{
        if(!isEmpty(newValue)){
            this.setState({
                searchInAllData:true,
                Value:newValue.label,
            })
            const userid = this.props.authUser.user_id;
            const Afid = this.props.authUser.user_Afid;
            this.props.searchKundBasic(newValue.value,Afid, userid)
        }
    }
    GetThisEjAktiveKund=async(newValue)=>{
        
        if(!isEmpty(newValue)){
            console.log(newValue,"asd")
            const userid = this.props.authUser.user_id;
            const Afid = this.props.authUser.user_Afid;
           await this.props.getnewKundByOrgnr(userid,Afid,newValue.Orgnr)
           //Jack 2023-03-02

            //this.props.setThisserchedKund(Kund)
            let newItem={
                value:newValue.Orgnr,
                label:newValue.KundNamn
            }
            let AktiveKund = this.state.AktivaKunder
            AktiveKund.push(newItem)
            this.setState({
                Value:newValue.KundNamn,
                AktivaKunder:AktiveKund,
                searchInAllData:false
            })
            setTimeout(()=>{
                if(this.props.isPersonlig === 0){
                    this.props.selectthisKund(newItem)
                }else{
                    console.log("Personlig")
                }                
            },500)
        }
    }
    /*
    GetTooltipDetails = async(orgnr) => {
        if(!isUndefined(orgnr)) {
            const userid = this.props.authUser.user_id;
            const Afid = this.props.authUser.user_Afid;
            this.props.getnewTooltipDetailsByOrgnr(userid,Afid,orgnr)
        }
    }
    */
    handleClose = () => {
        this.setState({
            searchInAllData:false
        })
    }
    render(){
      //   console.log(this.props.Value)
        console.log(this.props.optional, 'optional') 
        return (
            <React.Fragment>
                <Autocomplete
                    value={this.state.Value}
                    id="combo-box-demo"
                    options={this.state.AktivaKunder.slice(0, 1000)}
                    selectOnFocus
                    clearOnBlur
                    error={!this.props.optional && (!isUndefined(this.props.isFromRapport)?false:isEmpty(this.state.newKund.Orgnr))} 
                    handleHomeEndKeys
                    freeSolo
                    onChange={(event, newValue) => {
                        console.log(newValue,"newValue")
                        if(!isNull(newValue) && isObject(newValue)){
                        const filtered = isEmpty(this.state.AktivaKunder)?[]:this.state.AktivaKunder.filter(item => {
                            return item.label.toLowerCase().indexOf(newValue.label.toLowerCase()) > -1
                        }).slice(0, 5)
                        if(!isEmpty(filtered)){
                        this.selectthisKund(newValue)
                        }
                        }else{
                            if(isNull(newValue)){
                               this.props.onSetZeroKundSearch()
                            }
                        }

                    }}
                    fullWidth
                    filterOptions={(options, params) => {
                        const filtered =
                            isEmpty(params.inputValue)?
                            this.state.AktivaKunder.slice(0, 1000)
                            :
                            this.state.AktivaKunder.filter(item => {
                                return item.label.toLowerCase().indexOf(params.inputValue.toLowerCase()) > -1
                            }).slice(0, 150)
                       // console.log(filtered)
                        if(isEmpty(filtered)){
                            filtered.push({
                                value: params.inputValue,
                                label: <><IntlMessages id="Search"/>{params.inputValue}</>,
                                isAdd: true
                              });
                            }
                       return filtered;
                      }}
                    getOptionLabel={(option) => {
                        // e.g value selected with enter, right from the input
                        if (typeof option === 'string') {
                          return option;
                        }
                        if (option.label) {
                          return option.label;
                        }
                        return option.label;
                      }}
                    renderOption={(option) => {
                        
                            return (
                                <>
                                {
                                    isUndefined(option.isAdd) ?
                                    <div 
                                    >
                                        {
                                            isNull(option.Tele) && isNull(option.Email) ? option.label :
                                            <Tooltip title={
                                                <div>
                                                     {!isNull(option.Tele) ? <p><IntlMessages id="Tele"/> : {option.Tele}</p> : ''}
                                                    {!isNull(option.Email) ? <p><IntlMessages id="E-mail"/>: {option.Email}</p> : ''}
                                                </div>
                                            } placement="left">
                                                <div>
                                                {option.label}
                                                </div>
                                            </Tooltip>
                                        }
                                    
                                    </div> : 
                                    <Button  variant="contained" size="small"
                                    className={'bg-defualt'} 
                                    onClick={()=>{
                                        this.GetThisEjAktiveKunder(option)
                                    }}>
                                    <SearchIcon size="small"/>
                                    <IntlMessages id="Search.Customer"/>: {option.value}
                                    </Button>
                                }
                            
                            </>
                          );
                        }
                        // (isUndefined(option.isAdd)?option.label
                        // :<Button  variant="contained" size="small"
                        // className={'bg-defualt'} 
                        // onClick={()=>this.GetThisEjAktiveKunder(option)}>
                        //     <SearchIcon size="small"/>
                        //     <IntlMessages id="Search.Customer"/>: {option.value}
                        //     </Button>)
                            }
                    
                    renderInput={(params) => (
                      <TextField 
                      {...params} 
                        InputLabelProps={{ shrink: true }}
                        error={!this.props.optional && (!isUndefined(this.props.isFromRapport)?false:isEmpty(this.state.newKund.Orgnr))}    
                        label={<IntlMessages id="Customer.Choose"/>}
                        variant="outlined"
                        size="small"
                        InputProps={this.props.KundSearchLoading ? {
                          endAdornment: 
                            <InputAdornment position="end" style={{marginRight: -8}}>
                              <CircularProgress size={25}/>
                            </InputAdornment>
                        } : params.InputProps}
                        
                        />
                      )}
                />
                <Dialog open={this.state.searchInAllData} 
                onClose={this.handleClose} 
                aria-labelledby="form-dialog-title">
                     <DialogContent>
                     <Grid container>
                     <Grid item xs={12}>
                         {
                             this.props.IsloadingSearch===true?
                             <CircularProgress/>
                             :                        
                            <List dense>
                                  {
                                      isEmpty(this.props.searchedKundBasic)?
                                      <p><IntlMessages id="Search.Customer.message"/>
                                      </p>
                                      :
                                      this.props.searchedKundBasic.map(item =>{
                                          return (
                                            <ListItem 
                                            component={Button} 
                                            onClick={()=>{
                                                if(parseInt(item.Permission) === 2){
                                                    if(item.isPersonlig === 0){
                                                        if(isUndefined(item.hasnoAccess)){
                                                            this.GetThisEjAktiveKund(item)
                                                        }else{
                                                            if(parseInt(item.hasnoAccess) === 1){
                                                                console.log("hasnoAccess")
                                                            }
                                                            else{
                                                                this.GetThisEjAktiveKund(item)
                                                            }
                                                        }
                                                    
                                                    }
                                                }
                                            }}
                                            color={item.isPersonlig ===1 ?"secondary":
                                            parseInt(item.Permission) !== 2?"secondary":
                                            isUndefined(item.hasnoAccess)?"default":
                                            parseInt(item.hasnoAccess) === 1?"secondary":"default"}>
                                                <ListItemText
                                                    primary={item.isPersonlig === 1?
                                                        <>
                                                        {`${item.KundNamn} (${item.Orgnr})`}
                                                        <small> <IntlMessages id="Search.Customer.message1"/></small>
                                                        </>                                                        
                                                        :
                                                        parseInt(item.Permission) !== 2?
                                                        <>
                                                        {`${item.KundNamn} (${item.Orgnr})`}
                                                        <small> <IntlMessages id="Search.Customer.message1"/></small>
                                                        </>                                                        
                                                        :
                                                        `${item.KundNamn} (${item.Orgnr})`
                                                         }
                                                />
                                            </ListItem>
                                          )
                                      })
                                  }

                           </List> }
                     </Grid>
                     </Grid>
                     </DialogContent>
                </Dialog>
            </React.Fragment>
        )
    }
}
export default connect(
    mapStateToProps,mapDispatchToProps
)(KundAutoComplete);
